import { Component, ElementRef, Input, OnChanges, SimpleChanges, ViewChild } from '@angular/core';
import { Profile } from '@tekman/onmat/models';
import { EnvironmentService } from '@tekman/onmat/service/generic';

@Component({
  selector: 'hubspot',
  templateUrl: './hubspot.component.html',
})
export class HubspotComponent implements OnChanges {
  @Input() profile: Profile;

  private src = '//js.hs-scripts.com/{id}.js';
  type: string;
  @ViewChild('script') script: ElementRef;

  constructor(private env: EnvironmentService) {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes['profile'] !== undefined && changes['profile'].currentValue !== undefined) {
      if (this.isTeacherIn(changes['profile'].currentValue.roles)) {
        this.convertToScript();
      }
    }
  }

  convertToScript() {
    const element = this.script.nativeElement;
    const script = document.createElement('script');
    script.type = this.type ? this.type : 'text/javascript';
    if (this.src) {
      script.src = this.src.replace('{id}', this.env.settings.hubspot.key);
    }
    if (element.innerHTML) {
      script.innerHTML = element.innerHTML;
    }
    const parent = element.parentElement;
    parent.parentElement.replaceChild(script, parent);
  }

  private isTeacherIn(roles): boolean {
    return roles.includes('TEACHER') || roles.includes('COORDINATOR_ONMAT');
  }
}
